import { Injectable } from '@angular/core';
import { CombeniaService } from "../services/CombeniaService/CombeniaService";
import { CombeniaSyncService } from "../services/CombeniaService/CombeniaSyncService";
import { CombeniaItem } from "../services/CombeniaService/models/CombeniaItem";
import { AppConst } from "../services/CombeniaService/consts/AppConsts";
import { CombeniaAttribute } from '../services/CombeniaService/models/CombeniaAttribute';
import { UserModel } from './UserModel';
import { DatePipe } from '@angular/common';
export const OrderStatus = {
  COMPLETED: "completed",
  DRAFT: "draft",

}


export class OrderDetail{
  brand_code?:string="";
  sku?:string;
  quantity?:number;
  price_value?:number;

  unit_price?:number;
  brand_name?:string;
  description?:string;
  image?:string;
  invalidReason?:string;
  article_name?:string;
  brand_image?:string;
  isChecked?:boolean;
  stock?:number;
};

@Injectable()
export class OrderModel {
  id_order:string="";
  ecommerce:boolean=false;
  discount:boolean=false;
  id_store:string="";
  username:string="";
  order_date:string;


  details:Array<OrderDetail>=[];

  constructor(public combenia: CombeniaService, public sync: CombeniaSyncService,
     private user: UserModel,private datePipe: DatePipe ,
  ) {
    this.order_date=this.datePipe.transform(new Date(), 'yyyy-MM-dd');

  }
  

  async loadSku(detail:OrderDetail){
    return this.combenia.readEntity("articles", {
      action: "articlesInStoreBySkuOrArticleName",
      id_store:this.id_store,
      article_name: detail.article_name
    }).then((res:any)=>{
      if(res && res[0])
      {
        detail.brand_code=res[0].brand_code;
        detail.unit_price=res[0].price;
        detail.sku=res[0].sku;

      }
    })
    
  }

  async loadArticleFromStoreOrArticleName(detail: OrderDetail, orderDetList: Array<OrderDetail>, limit: number, offset: number) {
    return this.combenia.readEntity("articles", {
      action: "articlesByArticleNameOrBrand",
      id_store:this.id_store,
      article_name_search: detail.article_name,
      brand: detail.brand_code,
      offset: offset,
      order_column: "article_name",
      sort: "asc",
      limit: limit
    }).then(async (res:any)=>{
      if(res && res.length > 0)
      {
        res.forEach(el => {
          let det: OrderDetail = {};
          det.brand_code = el.brand_code;
          det.unit_price = el.price;
          det.article_name = el.article_name;
          det.sku = el.sku;
          det.brand_name = el.brand_descr;
          det.description = this.getArticleDescription(el);
          det.quantity = 1;
          det.stock = el.stock;
          orderDetList.push(det);
        })
        if(orderDetList && orderDetList.length > 0) {
          await this.loadSkuImages(orderDetList);
        } 
      }
    })
  }

  async addDetail(detail:OrderDetail){
    this.details.push(detail);
  }

  async removeDetail(detail:OrderDetail){
    this.details=this.details.filter((d:OrderDetail)=>{
        return d.sku!= detail.sku
    })
  }
  


  async completeSale(){
    this.generateIdOrder();
    let order={
      id_order:this.id_order,
      username:this.username,
      id_store:this.id_store,
      order_status:OrderStatus.COMPLETED,
      ecommerce:this.ecommerce?AppConst.YES:AppConst.NO,
      discount:this.discount?AppConst.YES:AppConst.NO,
      order_date:this.order_date.substring(0,10), //2019-06-17
      synch_status:"new",
    }
    let details=[];
    this.details.forEach((d)=>{
      if(d.sku && d.unit_price)
      {
        d["id_order"]=this.id_order;
        d["username"]=this.username;
        d["id_store"]=this.id_store;
        d["id_supplier"]="KERING";
        d["synch_status"]="new";
        d["order_status"]=OrderStatus.COMPLETED;
        d["order_date"]=this.order_date.substring(0,10);
        d.price_value=d.quantity* d.unit_price;      
        details.push(d)
      }
      
    })
    let toWrite={
      orders:[order],
      orderDetails:details,
    }

    await this.combenia.writeEntities(toWrite);
    

  }
  clearOrder(){
    this.id_order="";
    this.ecommerce=false;
    this.discount=false;
    this.details=[];
    this.id_store="";
    this.username="";
    this.order_date=this.datePipe.transform(new Date(), 'yyyy-MM-dd');
  }

  isOrderCreated(){
    return this.id_order;
  }


  async generateIdOrder(){

    this.id_order="web_"+this.username+this.datePipe.transform(new Date(), "yyyyMMdd_HHmmss");
    
  }

  getArticleDescription(article:any) {
    let description = "";
    if(article) {
      if(article.article_name != null && article.article_name != undefined) {
        description += article.article_name;
      }
      if(article.shape_descr != null && article.shape_descr != undefined) {
        description += " " + article.shape_descr;
      }
      if(article.sku_descr != null && article.sku_descr != undefined) {
        description += " " + article.sku_descr;
      }
    }
   // console.log(description)
    return description;
  }

  async loadSkuImages(list): Promise<any> {
    list = list.filter((el) => {
      return el.image == undefined
    })
    let skus= list.map((l)=>{
      return l.sku
    })
    let res = await this.combenia.getItemsByCriteria({
        types: ['skuImage'],
        attributes: [{
            name: 'sku',
            in: skus
        }]
    });
    let items = <CombeniaItem[]> res;
    items.forEach((item:CombeniaItem)=>{
      let sku=this.getAttrValue(item, "sku");
      let image:CombeniaAttribute=this.getAttribute(item, "imageSmall");
      if(image) {
        let url=image.value.url; 
       // let url=this.documentProvider.getResourceUrl(image); 
        list.forEach((l)=>{
          if(l.sku==sku)
            l.image=url;
        })
      } else {
        console.log(sku)
      }
    })
  }

  getAttrValue(item: CombeniaItem, attrName:string){ 
    let finded= this.getAttribute(item, attrName);
    if(!finded)
      return null;
    return finded.value;
  }
  getAttribute(item: CombeniaItem, attrName:string){
    let finded= item.attributeList.find((a)=>{
      return a.name==attrName;
    })
    if(!finded)
      return null;  
    return finded;

  }
  

  
}

